export { UIKitConfigProvider, UIKitConfigContext, useUIKitConfig } from './context.js';
export { initialConfig } from './initialConfig.js';
